.title {
  font-size: 0.9375rem;
  flex-basis: 33.33%;
  flex-shrink: 0;
  flex: 1;
}

.subtitle {
  font-size: 0.9375rem;
}
